export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.kam) {
        return {...state, ...payload.kam};
      }
      return state;
    }
  }
};
